export default {
  oneWayTitle: {
    id: 'sav_platform_product_returns_one_way_return_title',
    defaultMessage: 'One way',
  },
  twoWayTitle: {
    id: 'sav_platform_product_returns_two_way_return_title',
    defaultMessage: 'Two way',
  },
  creationDate: {
    id: 'sav_platform_product_returns_creation_date_short',
    defaultMessage: 'Created on {date, date, short}',
  },
  shipmentSource: {
    id: 'sav_platform_product_returns_shipment_source',
    defaultMessage: `{source, select,
      MANUAL {Manual}
      other {Backship}
    } return label`,
  },
  backToCustomerPickUpDate: {
    id: 'sav_platform_product_returns_back_to_customer_pickup_date',
    defaultMessage: 'Re-shipped to customer on {date, date, short}',
  },
  customerDeliveryDate: {
    id: 'sav_platform_product_returns_customer_delivery_date',
    defaultMessage: 'Arrived at customer the {date, date, short}',
  },
  delivered: {
    id: 'asp_product_returns_delivered_date',
    defaultMessage: 'Delivered on {date, date, short}',
  },
  shippedByCustomer: {
    id: 'asp_product_returns_shipped_by_customer_date',
    defaultMessage: 'Shipped by customer on {date, date, short}',
  },
}
